import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import { frontendURL } from 'dashboard/helper/URLHelper';
import VoiceCenterIndex from './VoiceCenterIndex.vue';
import VoiceQueuesIndex from './VoiceQueuesIndex.vue';

const voiceRouteMeta = {
  permissions: ['administrator', 'inbox_manage'],
  featureFlag: FEATURE_FLAGS.CHANNEL_VOICE,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/voice-queues'),
    name: 'voice_queues_index',
    component: VoiceCenterIndex,
    meta: voiceRouteMeta,
  },
  {
    path: frontendURL('accounts/:accountId/voice-queues/settings'),
    name: 'voice_queues_settings',
    component: VoiceQueuesIndex,
    meta: voiceRouteMeta,
  },
];
